import { Option, Select, Stack, Box } from '@mui/joy';
import { useMemo } from 'react';
import { useGetCategoriesQuery } from '../api';
import { EmojiDisplay } from '@/components/EmojiDisplay';

// Subcategory picker grouped under non-selectable category headings. Deals in
// string ids throughout — callers convert to whatever their own state wants.
// CategoryPicker wraps this for react-hook-form; bulk edit uses it directly.
export function SubcategorySelect({ value, onChange, optional, ...selectProps }) {
  const { data, isLoading } = useGetCategoriesQuery({});

  const categories = data?.data || [];

  const options = useMemo(() => {
    const opts = [];
    categories.forEach(cat => {
      opts.push({
        type: 'category',
        id: `category-${cat.id}`,
        name: cat.name,
        emoji: cat.emoji,
        disabled: true
      });
      if (cat.subcategories && cat.subcategories.length > 0) {
        cat.subcategories.forEach(sub => {
          opts.push({
            type: 'subcategory',
            id: sub.id + '',
            name: sub.name,
            emoji: sub.emoji,
            categoryName: cat.name,
            disabled: false
          });
        });
      }
    });
    return opts;
  }, [categories]);

  return (
    <Select
      placeholder={optional ? "Select subcategory (optional)" : "Select subcategory"}
      value={value ? String(value) : ''}
      onChange={(_, newValue) => onChange(newValue)}
      disabled={isLoading}
      {...selectProps}
    >
      {optional && <Option value="">None</Option>}
      {options.map((option) => {
        if (option.type === 'category') {
          return (
            <Option
              key={option.id}
              value={option.id}
              disabled
              sx={{
                fontWeight: '700',
                color: 'var(--joy-palette-neutral-900) !important',
                backgroundColor: 'var(--joy-palette-neutral-50)',
                '&:hover': {
                  backgroundColor: 'var(--joy-palette-neutral-50)',
                }
              }}
            >
              <Stack direction="row" spacing={1} alignItems="center">
                {option.emoji && <EmojiDisplay emoji={option.emoji} size={16} />}
                <span>{option.name}</span>
              </Stack>
            </Option>
          );
        } else {
          return (
            <Option key={option.id} value={String(option.id)}>
              <Box sx={{ pl: 3 }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  {option.emoji && <EmojiDisplay emoji={option.emoji} size={16} />}
                  <span>{option.name}</span>
                </Stack>
              </Box>
            </Option>
          );
        }
      })}
    </Select>
  );
}
